// the errorObj keys should be the same as the element (input) id for this to work
export const scrollToElement = (errorObj) => {
    const firstError = Object.keys(errorObj).find((el) => errorObj[el].error);
    firstError && document.getElementById(firstError)?.focus();
};

export const scrollToFocus = (ref) => {
    if (!ref?.current) return;
    const headerHeight = 200;
    const currentTop = ref.current.getBoundingClientRect().top - headerHeight;
    window.scrollBy({
        top: currentTop,
        behavior: 'smooth'
    });
};
